import Vue from "vue";
import App from "./App.vue";
import router from "./routes";
import store from "./store";
import * as WebFont from "webfontloader";
import VueGtag from "vue-gtag";

require("@/styles/global.scss");

// set error handlers only for production build
if (process.env.NODE_ENV === "production") {
  var Rollbar = require("vue-rollbar");
  Vue.use(Rollbar, {
    accessToken: "78b310071cdb4daaa02d254af493a08d",
    captureUncaught: true,
    captureUnhandledRejections: true,
    enabled: true,
    environment: "production",
    payload: {
      client: {
        javascript: {
          code_version: "1.0",
          source_map_enabled: true,
          // Optionally have Rollbar guess which frames the error was
          // thrown from when the browser does not provide line
          // and column numbers.
          guess_uncaught_frames: true,
        },
      },
    },
  });

  Vue.config.errorHandler = err => {
    Vue.rollbar.error(err);
  };

  window.onerror(err => {
    Vue.rollbar.error(err);
  });
}

// Google Analytics
// only use google analytics on production builds
if (process.env.VUE_APP_ENV === "prod" && process.env.VUE_APP_GTAG_ID) {
  Vue.use(VueGtag, {
    config: { id: process.env.VUE_APP_GTAG_ID },
  });
}

// Load material icons
WebFont.load({
  google: {
    families: ["Material Icons"],
  },
  timeout: 10000, // 10 seconds of timout
});

// vue notifications
import Notifications from "vue-notification";
Vue.use(Notifications);

// Scroll bars
import "simplebar/dist/simplebar.min.css";
import simplebar from "simplebar-vue";
Vue.component("simplebar", simplebar);

// copy to clipboard
import Clipboard from "v-clipboard";
Vue.use(Clipboard);

// goole auth
import GAuth from "vue-google-oauth2";
Vue.use(GAuth, {
  clientId:
    "524074856481-jv7mr2opq1alpji4eobhplka73j9tkbg.apps.googleusercontent.com",
  scope: "profile email",
  prompt: "select_account",
});

// apex charts
import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

// vue helmet for page headers
import vueHeadful from "vue-headful";
Vue.component("vue-headful", vueHeadful);

// Range slider
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
Vue.component("VueSlider", VueSlider);

// vue portal
import PortalVue from "portal-vue";
Vue.use(PortalVue);

// vue click outside directive
import vClickOutside from "v-click-outside";
Vue.use(vClickOutside);

// global components
import DropDown from "@/components/global/views/DropDown";
import MultiSelectDropDown from "@/components/global/views/MultiSelectDropDown";
import NotFound from "@/components/global/views/NotFound";
import ThemeSwitcher from "@/components/global/views/ThemeSwitcher";
import PageHeading from "@/components/global/views/PageHeading";
import Spinner from "@/components/global/views/Spinner";
import ProgressView from "@/components/global/views/ProgressView";
import LoadingBar from "@/components/global/views/LoadingBar";
import InfoTooltip from "@/components/global/views/InfoTooltip";
import Icon from "@/components/global/views/Icon";
import Expand from "@/components/global/views/Expand";
import Btn from "@/components/global/views/Btn";

Vue.component("MultiSelectDropDown", MultiSelectDropDown);
Vue.component("DropDown", DropDown);
Vue.component("NotFound", NotFound);
Vue.component("ThemeSwitcher", ThemeSwitcher);
Vue.component("PageHeading", PageHeading);
Vue.component("Spinner", Spinner);
Vue.component("ProgressView", ProgressView);
Vue.component("LoadingBar", LoadingBar);
Vue.component("InfoTooltip", InfoTooltip);
Vue.component("Icon", Icon);
Vue.component("Expand", Expand);
Vue.component("Btn", Btn);

//Vue.googleAuth().load();

Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount("#app");
